
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { User } from '@/types/user';
import { LeaderboardEntry } from './LeaderboardTypes';

interface UserRankCardProps {
  user: User;
  userProgress: any;
  currentUserRank: number;
  selectedZone: string | null;
  userLeaderboardEntry: LeaderboardEntry | undefined;
}

const UserRankCard: React.FC<UserRankCardProps> = ({ 
  user, 
  userProgress, 
  currentUserRank, 
  selectedZone,
  userLeaderboardEntry 
}) => {
  return (
    <Card className="mb-8">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">Your Ranking</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between p-4 rounded-lg bg-hormony-beige/10">
          <div className="flex items-center gap-4">
            <div className="bg-hormony-coral/20 rounded-full p-2 w-10 h-10 flex items-center justify-center text-hormony-coral font-semibold">
              {currentUserRank}
            </div>
            <Avatar className="h-10 w-10">
              <AvatarImage src={user.avatar} alt={user.name} />
              <AvatarFallback>{user.name.charAt(0)}</AvatarFallback>
            </Avatar>
            <div>
              <p className="font-medium">{user.name}</p>
              <p className="text-sm text-muted-foreground">You</p>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <p className="text-sm text-muted-foreground">Points</p>
              <p className="font-medium text-hormony-coral">
                {selectedZone ? userLeaderboardEntry?.zones?.[selectedZone] || 0 : userProgress.points}
              </p>
            </div>
            <div className="text-center">
              <p className="text-sm text-muted-foreground">Streak</p>
              <p className="font-medium text-hormony-coral">
                {userProgress.streak} days
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserRankCard;
